export default __webpack_public_path__ + "static/media/channel_mojitok_img_01.271c3a53.png";